// components/UserPrivateRoute.js
import React from "react";
import { Navigate } from "react-router-dom";

const UserPrivateRoute = ({ children }) => {
  const token = localStorage.getItem("userPublicToken");
  return token ? children : <Navigate to="/request-otp" />;
};

export default UserPrivateRoute;
